export const analyticsEvents = {
  socialSharingSettingChanged: 'edx.social.video_sharing_setting.changed',
};
